import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { conformToMask } from 'react-text-mask';
import { get } from 'lodash';

import { phoneNumberMask } from '../../utils/masks';
import Header from '../../components/Header';
import Button from '../../components/Button';
import Input from '../../components/Form/Input';
import ApplicationId from '../../components/ApplicationId';
import { numberUnmask } from '../../utils/unmasks';
import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import { resendOTPText, newCheckInAction } from '../../actions/navigation';

import './style.scss';

const ResendOTP = (props) => {
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [errors, setErrors] = useState('');

  const handleSubmit = (e) => {
    e && e.preventDefault();
    const params = parseUrlParams(window.location.search);

    setIsSending(true);
    setErrors('');

    props.resendOTPText({
      workflowType,
      key: params.key,
      data: {
        to: numberUnmask(phoneNumber),
      },
      success: (res) => {
        if (res.status === 'pending') {
          props.newCheckInAction({
            workflowType,
            key: get(params, 'key'),
            success: () => {
              setIsSending(false);
              props.navigate(addLusaHeaderParam(`/${workflowType === 'dtm-luwa' ? 'luwa' : workflowType}/otp?key=${params.key}&resend=true`));
            },
          });
        } else {
          setIsSending(false);
        }
      },
      fail: (error) => {
        setIsSending(false);
        if (error?.response?.data?.errorMessage) {
          setErrors(error.response.data.errorMessage);
        } else if (error?.response?.data?.errorMessages && error.response.data.errorMessages.length > 0) {
          setErrors(error.response.data.errorMessages[0]);
        }
      },
    });
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header navigate={props.navigate} />
      {get(props.checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <div className="content" style={{ minHeight: 'calc(100vh - 200px)' }}>
        <p>Please confirm your phone number</p>
        <form className="resendForm" onSubmit={handleSubmit}>
          <Input
            type="text"
            name="phoneNumber"
            inputMode="numeric"
            isMasked={phoneNumberMask}
            value={phoneNumber ? conformToMask(phoneNumber, phoneNumberMask).conformedValue : ''}
            placeHolder="(___) ___-____"
            onChange={(e) => setPhoneNumber(e.target.value)}
            label=""
          />
          {errors ? <div className="alert-container">{errors}</div> : null}
          <Button
            color="primary"
            className="btn btn-primary verify-text-btn"
            onClick={handleSubmit}
            isLoading={isSending}
            isDisabled={isSending || !phoneNumber}
            title="Resend Verification Code"
          />
        </form>
      </div>
    </div>
  );
};

ResendOTP.propTypes = {
  navigate: PropTypes.func.isRequired,
  resendOTPText: PropTypes.func.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  resendOTPText,
  newCheckInAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResendOTP);
